import { render, staticRenderFns } from "./PurchaseOrdersDataTable.template.vue?vue&type=template&id=33938b7e&scoped=true&"
var script = {}
import style0 from "./PurchaseOrdersDataTable.template.vue?vue&type=style&index=0&id=33938b7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33938b7e",
  null
  
)

export default component.exports